/*
 *
 * File JS list Cards
 *
 */

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './marquee.scss';

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const marquee = () => {
    let allMarquee = document.querySelectorAll('.marquee');
    if (!allMarquee.length) return;

    allMarquee.forEach((marquee) => {
        let loop_container = marquee.querySelector('.marquee__loop');
        let content = marquee.querySelector('.marquee__content');
        let string = marquee.querySelector('.marquee__content').textContent;

        repeatContent(content, window.innerWidth);

        function repeatContent(el, till) {
            let counter = 0;
            while (el.offsetWidth <= till && counter < 100) {
                content.textContent = content.textContent + '' + string;
                counter += 1;
            }
            content.textContent =
                content.textContent + '' + content.textContent;

            const vel = 50;
            let towidth = el.offsetWidth / 2;
            const duration = towidth / vel;
            loop_container.setAttribute(
                'style',
                'animation-duration:' +
                    duration +
                    's;  --to-width:-' +
                    towidth.toString() +
                    'px;'
            );

            loop_container.classList.add('active');
        }

        window.addEventListener('resize', () => {
            content.textContent = '';
            repeatContent(content, window.innerWidth);
        });
    });
};

export default marquee;

//--------------------------------------------------------------------//
